/**
 * Mask input to Turkish mobile format: "+90 5XX XXX XX XX"
 * Strips non-digits, drops country prefix, caps at 10 subscriber digits.
 */
export const maskTurkishPhone = (raw: string): string => {
  let digits = raw.replace(/\D/g, "");
  if (digits.startsWith("90")) digits = digits.slice(2);
  if (digits.startsWith("0")) digits = digits.slice(1);
  digits = digits.slice(0, 10);
  if (digits.length === 0) return "";
  let out = "+90 " + digits.slice(0, 3);
  if (digits.length > 3) out += " " + digits.slice(3, 6);
  if (digits.length > 6) out += " " + digits.slice(6, 8);
  if (digits.length > 8) out += " " + digits.slice(8, 10);
  return out;
};
